// QuestionSetListCardCarousel.js
import React, { useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
  Button
} from "reactstrap";
import { useNavigate } from "react-router-dom";

import { Star, Dot } from 'lucide-react';
import VipBadge from "../../../components/VipBadge";

import placeholder_image from "assets/images/info/card-placeholder-medium.png";

import "./UserInfoTopicEditorCardCarousel.css";

function formatFollowCount(count) {
  if (count >= 1_000_000) {
    return (count / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'm';
  } else if (count >= 1_000) {
    return (count / 1_000).toFixed(1).replace(/\.0$/, '') + 'k';
  }
  return count.toString();
}

function getVisualLength(str) {
  let len = 0;
  for (const char of str) {
    // If full-width (CJK) character, count as 2
    if (/[\u4e00-\u9fa5\u3400-\u4DBF\uF900-\uFAFF]/.test(char)) {
      len += 2;
    } else {
      len += 1;
    }
  }
  return len;
}

function truncateByVisualLength(str, maxLen) {
  let len = 0;
  let result = '';

  for (const char of str) {
    const charLen = /[\u4e00-\u9fa5\u3400-\u4DBF\uF900-\uFAFF]/.test(char) ? 2 : 1;
    if (len + charLen > maxLen) break;
    result += char;
    len += charLen;
  }

  return result + (len < getVisualLength(str) ? '...' : '');
}


const CardCarousel = ({ cards, imageMap }) => {

  const navigate = useNavigate();

  return (
    <div className="question-set-list-carousel-container">
      <div className="question-set-list-carousel-cards-wrapper" style={{ paddingLeft: "30px" }}>
        <div className="question-set-list-carousel-cards-inner">

          {cards.length === 0 && 
            <div
              className={`question-set-list-ranked-carousel-card`}
              style={{ 
                fontSize: "14px",
                color: "black"
              }}
              onClick={() => {}}
            >
              <div style={{ marginBottom: "5px", position: "relative" }}>
                <div className='question-set-list-carousel-img-placeholder'>
                  <p className="question-set-list-carousel-img-placeholder-text">還沒有題組喔</p>
                </div>
              </div>
              <div style={{ position: "relative", width: "100%"}}>
                <div style={{
                  display: "flex",
                  flexDirection: "column",
                  padding: "0px 3px"
                }}>
                </div>

              </div>
            </div>
          }

          {cards.length !== 0 && cards.map((card, idx) => {
            return (
              <div
                key={card._id}
                className={`question-set-list-ranked-carousel-card`}
                style={{ 
                  fontSize: "14px",
                  color: "black"
                }}
                onClick={() => {}}
              >
                <div style={{ marginBottom: "5px", position: "relative", width: "100%" }}>
                  <img className='question-set-list-carousel-img'
                    src={
                      card?.image && imageMap.has(card.image)
                        ? imageMap.get(card.image)
                        : placeholder_image
                    }
                    alt={card.title}
                    style={{ }}
                    onClick={()=>{ navigate(`/myInfo/editQuestionSet/${card?._id}`); }}
                  />
                </div>
                <div style={{ position: "relative", width: "100%"}}>
                  <div style={{
                    display: "flex",
                    flexDirection: "column",
                    padding: "0px 3px"
                  }}>
                    <p className="mb-0" style={{ fontSize: '15.5px', maxWidth: "95%" }}>
                      {truncateByVisualLength(card?.label || '', 16)}
                    </p>
                    <p style={{ fontSize: '13.5px', color: '#ed8f71', fontWeight: 'bold', margin: '0px 0px 3.5px 0px' }}>
                      {`Tpoint ${card?.pointsAward || 0} 點`}
                    </p>

                    {/* Star and VIP level */}
                    <Row>
                      <Col className="question-set-list-topic-star-col">
                        <div className="d-flex">
                          <p className="mb-0">{card.rating}</p>
                          <Star size={18} fill="#faca82" stroke="none"
                            style={{ margin: '1.8px 2px 0px 2px' }}
                          />
                          {/* A filled star */}
                          <p className="mb-0 text-muted" style={{ fontSize: '13.5px' }}>{`(${card?.reviewCount || 0}+)`}</p>
                        </div>
                        <div style={{ margin: '0px 2px 5px 2px' }}>
                          <Dot size={16} /> {/* You can also use a styled div for a smaller solid dot */}
                        </div>
                        <Button color="soft-success" 
                          style={{
                            height: "30px",
                            padding: "0px 5px 2px 5px"
                          }}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            e.currentTarget.blur();
                            return false;
                          }}
                        >
                          {formatFollowCount(card?.followCount || 0)}+
                        </Button>
                      </Col>
                    </Row>

                  </div>

                </div>
              </div>
            )
          })}

        </div>
      </div>

    </div>
  );
};

export default CardCarousel;
